import { useMemo } from 'react'
import useOffer from 'hooks/Offers/useOffer'
import { isBedbankOffer } from 'lib/offer/offerTypes'
import calculateDistance from 'lib/geo/distanceBetweenPoints'

interface Props {
  offer: App.HotelOffer | App.HotelOfferSummary | App.BedbankOffer | App.BedbankOfferSummary
  filters?: App.OfferListFilters
}

function useMetaSearchDistance({ offer, filters }: Props) {
  const [metaOffer] = useOffer(filters?.showDistanceWithMetaOfferId, {
    requireSummaryOnly: true,
  })

  const metaSearchDistanceToMainOffer = useMemo(() => {
    if (filters?.showDistanceWithMetaOfferId && isBedbankOffer(metaOffer)) {
      const result = Math.ceil(calculateDistance(offer.property.latitude, offer.property.longitude, metaOffer.property.latitude, metaOffer.property.longitude) * 10) / 10
      return result <= 10 ? result : 0
    }
    return 0
  }, [filters?.showDistanceWithMetaOfferId, offer, metaOffer])

  return metaSearchDistanceToMainOffer
}

export default useMetaSearchDistance
